import { Helper } from '../Helper';
export class ConsoleLogHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitHelper(node, options, sb.helpers.wrapArray);
        sb.emitHelper(node, options, sb.helpers.genericLogSerialize);
        sb.emitSysCall(node, 'Neo.Runtime.Serialize');
        sb.emitLine(node);
        sb.emitPushString(node, 'console.log');
        sb.emitPushInt(node, 3);
        sb.emitOp(node, 'PACK');
        sb.emitSysCall(node, 'Neo.Runtime.Notify');
    }
}

//# sourceMappingURL=ConsoleLogHelper.js.map
